import { createSignal, onMount } from "solid-js";
import { useApplication } from "@/context/app";
import {
  Card,
  CardContent,
} from "@/components/shadcn/card";
import { activateAction, deactivateAction, deleteAction } from "../../components/ui/actions/config";
import { ListControl } from "../../components/ui/list/ListControl";
import AppointmentRow from "./row";
import { ListView } from "../../components/ui/list/ListView";
import { CreateButton } from "../../components/ui/Button";

export default function AppointmentList() {

  const { setBreadcrumb } = useApplication();

  const actions = [
  ];

  const statuses = [{
    text: 'Active',
    value: true
  }, {
    text: 'Inactive',
    value: false
  }];

  const sorts = [{
    "text": 'Created At',
    "value": "created_at"
  }, {
    "text": 'Date',
    "value": "date"
  }];

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: 'Appointments',
        current: true
      }
    ]);
  });

  return (
    <>
      <Card class="w-full">
        <CardContent>
          <ListControl
            mode="list"
            search={''}
            actions={actions}
            filters={[
              {
                type: 'choice',
                label: 'Status',
                name: 'status',
                choices: statuses,
                default: null
              },
              {
                type: 'date',
                label: 'Created At',
                name: 'created_at',
                default: null
              }
            ]}
            sort={{
              column: 'created_at',
              direction: 'asc',
              options: sorts
            }}
            pagination={{
              current: 1, // default 1
              changePerPage: true, // default true
              perPage: 10, // default 10
              options: [10, 20, 50, 100]
            }}
            datasource={{
              type: 'remote',
              config: {
                url: '/appointment/fetch',
                method: 'GET',
                params: {
                  //status: status()
                }
              }
            }}
            contentLoading={false}
          >{(innerProps) => <ListView {...innerProps} template={AppointmentRow} placeholder={false} />}
          </ListControl>
        </CardContent>
      </Card>
    </>
  );
}
